import { useQueries } from "@tanstack/react-query";
import api from "services/api";
import { IOrganization } from "./AddressableSetup.types";
import { useAuth } from "contexts/auth";
import { Box, CircularProgress, Typography } from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";
import { AddressableSetupListClients } from "./AddressableSetup.ListClients";

export function AddressableSetup() {
  const user = useAuth();
  const federalTaxPayerId = user.user?.organization?.cnpj;

  const [organizationsResult] = useQueries({
    queries: [
      {
        queryKey: ["addressable-setup-clients", federalTaxPayerId],
        queryFn: () => api.get<{ data: IOrganization[] }>(`/v2/addressable/rules/${federalTaxPayerId}`),
        select: (data: any) => data?.data?.data as IOrganization[],
      },
    ],
  });

  const isLoading = (!organizationsResult.isFetched && organizationsResult.isFetching);
  const isError = (!organizationsResult.isFetched && organizationsResult.isError);
  
  const organizations = organizationsResult.data as IOrganization[] | undefined;
  
  return (
    <>
      {isLoading && (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="400px" gap={3}>
          <CircularProgress size={20} thickness={4} />
        </Box>
      )}
      {isError && (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="400px" gap={3} textAlign="center">
          <ErrorOutline sx={{ fontSize: 40, color: 'error.main' }} />
          <Typography variant="h6" color="textPrimary">Ops! Algo deu errado</Typography>
          <Typography variant="body1" color="textSecondary" maxWidth={400}>Não foi possível carregar a listagem de clientes. Por favor, tente novamente.</Typography>
        </Box>
      )}
      {organizations && (
        <AddressableSetupListClients
          data={organizations}
          refetchOrganizations={organizationsResult.refetch}
        />
      )}
    </>
  )
}
